// БАГАЖ
// 1 место ${name}

import { i18n } from '@lt/localization';

// Нет информации о ${without}
export const LUGGAGE_TYPE = {
  HOLD: 'hold',
  WITHOUT_HOLD: 'without_hold',
  HAND: 'hand',
  SKI_EQUIPMENT: 'ski_equipment',
} as const;

export const LUGGAGE_NAME = {
  [LUGGAGE_TYPE.HOLD]: i18n.t('checkout.flight.luggage.hold'),
  [LUGGAGE_TYPE.WITHOUT_HOLD]: i18n.t('checkout.flight.luggage.withoutHold'),
  [LUGGAGE_TYPE.HAND]: i18n.t('checkout.flight.luggage.hand'),
  [LUGGAGE_TYPE.SKI_EQUIPMENT]: i18n.t('checkout.flight.luggage.ski.name'),
};

export const LUGGAGE_DIFFERENCE_LABEL_DATA_TEST_ID =
  'LUGGAGE_DIFFERENCE_LABEL_DATA_TEST_ID';
